import { render, staticRenderFns } from "./exportDespachoCALMED.vue?vue&type=template&id=fe4dd4ee&scoped=true"
import script from "./exportDespachoCALMED.vue?vue&type=script&lang=js"
export * from "./exportDespachoCALMED.vue?vue&type=script&lang=js"
import style0 from "./exportDespachoCALMED.vue?vue&type=style&index=0&id=fe4dd4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4dd4ee",
  null
  
)

export default component.exports